<template>
  <div class="dropdown-container">
    <DropdownPrime 
      v-model="selectedValues" 
      :options="options" 
      optionLabel="Glosa" 
      optionValue="Id" 
      placeholder="Comuna" 
      :class="{'p-invalid': mostrarErrores && error}" 
      v-tooltip="tooltipOpts"
      @change="emitSelection"
      :multiple="isMultiple"
    />
    <small v-if="mostrarErrores && error" class="p-error">{{ error }}</small>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  props: {
    mostrarErrores: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [Number, Array], // Cambiar a tipo Array para manejar múltiples selecciones
      default: () => null
    },
    allowMultiple: { // Nuevo parámetro para definir si se permite seleccionar múltiples
      type: Boolean,
      default: false
    }
  },
  computed: {
    tooltipOpts() {
      return {
        value: this.tooltip || '',
        position: 'bottom',
        disabled: !String(this.tooltip || '').trim(),
      };
    },
  },
  setup(props, { emit }) {
    const options = ref([]);
    const selectedValues = ref(Array.isArray(props.modelValue) ? props.modelValue : [props.modelValue]); // Inicializa como array

    const fetchOptions = () => {
        options.value = [
    { Id: 45, Glosa: 'Valparaíso' },
    { Id: 46, Glosa: 'Casablanca' },
    { Id: 47, Glosa: 'Concón' },
    { Id: 48, Glosa: 'Juan Fernández' },
    { Id: 49, Glosa: 'Puchuncaví' },
    { Id: 50, Glosa: 'Quilpué' },
    { Id: 51, Glosa: 'Quintero' },
    { Id: 52, Glosa: 'Villa Alemana' },
    { Id: 53, Glosa: 'Viña del Mar' },
    { Id: 54, Glosa: 'Isla de Pascua' },
    { Id: 55, Glosa: 'Los Andes' },
    { Id: 56, Glosa: 'Calle Larga' },
    { Id: 57, Glosa: 'Rinconada' },
    { Id: 58, Glosa: 'San Esteban' },
    { Id: 59, Glosa: 'La Ligua' },
    { Id: 60, Glosa: 'Cabildo' },
    { Id: 61, Glosa: 'Papudo' },
    { Id: 62, Glosa: 'Petorca' },
    { Id: 63, Glosa: 'Zapallar' },
    { Id: 64, Glosa: 'Quillota' },
    { Id: 65, Glosa: 'La Calera' },
    { Id: 66, Glosa: 'Hijuelas' },
    { Id: 67, Glosa: 'La Cruz' },
    { Id: 68, Glosa: 'Limache' },
    { Id: 69, Glosa: 'Nogales' },
    { Id: 70, Glosa: 'Olmué' },
    { Id: 71, Glosa: 'San Antonio' },
    { Id: 72, Glosa: 'Algarrobo' },
    { Id: 73, Glosa: 'Cartagena' },
    { Id: 74, Glosa: 'El Quisco' },
    { Id: 75, Glosa: 'El Tabo' },
    { Id: 76, Glosa: 'Santo Domingo' },
    { Id: 77, Glosa: 'San Felipe' },
    { Id: 78, Glosa: 'Catemu' },
    { Id: 79, Glosa: 'Llay-Llay' },
    { Id: 80, Glosa: 'Panquehue' },
    { Id: 81, Glosa: 'Putaendo' },
    { Id: 82, Glosa: 'Santa María' }
];


    };

    const emitSelection = () => {
      emit('update:modelValue', selectedValues.value); // Emite como array o valor único
    };

    onMounted(() => {
      fetchOptions(); // Cargar las opciones al montar el componente
    });

    return {
      options,
      selectedValues,
      emitSelection,
      isMultiple: props.allowMultiple,
    };
  }
}
</script>

<style scoped>
.dropdown-container {
  margin-bottom: 1rem;
}
</style>
